import { useState } from 'react';
function TaskItem({ task, onRemove }) {
	return (
		<div>
			<p>{task}</p>
			<button onClick={onRemove}>Remove</button>
		</div>
	);
}

export default TaskItem